import { createSelector } from "reselect";

import { GroupType } from "@superblocksteam/shared";
import type { AccessMode } from "@superblocksteam/shared";

import { getSuperblocksHQOrgName } from "env";
import type { User } from "legacy/constants/userConstants";
import type { UserPermissionsMap } from "legacy/reducers/uiReducers/usersReducer";
import { selectOnlyOrganization } from "store/slices/organizations/selectors";
import type { AppState } from "store/types";

export const getCurrentUser = (state: AppState): User | undefined =>
  state.legacy.ui.users.currentUser;
export const getAccessMode = (state: AppState): AccessMode | undefined =>
  state.legacy.ui.users.accessMode;
export const getIsSuperUser = (state: AppState): boolean =>
  Boolean(
    state.legacy.ui.users.currentUser?.groups.some(
      (group) => group.type === GroupType.SUPER_USER,
    ),
  );

export const getCurrentUserIsAdmin = (state: AppState): boolean =>
  Boolean(state.legacy.ui.users.currentUser?.isAdmin);

export const getIsOrgSwitched = createSelector(
  getIsSuperUser,
  selectOnlyOrganization,
  (isSuperUser, currentOrg): boolean => {
    const superblocksOrgName = getSuperblocksHQOrgName();
    return Boolean(
      isSuperUser &&
      superblocksOrgName &&
      currentOrg?.name !== superblocksOrgName,
    );
  },
);

export const getUserPermissionsMap = (
  state: AppState,
): UserPermissionsMap | undefined => state.legacy.ui.users.permissionsMap;
